import '../scss/category-page-style.scss';
import CategoryPage from './pages/blog/category/index';

document.addEventListener('DOMContentLoaded', () => {
  CategoryPage.init();
});